import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string | string, MessageDescriptor> = defineMessages({
	project: {
		id: 'search-graph-jira-dc.project-result.label',
		defaultMessage: 'Project',
		description: 'Project label',
	},
	space: {
		id: 'search-graph-jira-dc.space-result.label',
		defaultMessage: 'Space',
		description: 'Space label',
	},
	issue: {
		id: 'search-graph-jira-dc.issue-result.label',
		defaultMessage: 'Work item',
		description: 'Issue label',
	},
	commment: {
		id: 'search-graph-jira-dc.comment-result.label',
		defaultMessage: 'Comment',
		description: 'Comment label',
	},
});
